function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.4499344,0.202449388 C2.71986693,-0.0674831292 3.15975698,-0.0674831292 3.42968951,0.202449388 C3.42968951,0.202449388 3.42968951,0.202449388 3.42968951,0.202449388 L7.70862,4.48137966 C7.97855253,4.75131217 7.97855253,5.1912022 7.70862,5.46113472 C7.70862,5.46113472 7.70862,5.46113472 7.70862,5.46113472 L3.37970201,9.79005249 C3.3097195,9.86003499 3.22973949,9.92002 3.13976198,9.9500125 C3.05978197,9.980005 2.96980446,10 2.87982695,10 C2.68987443,10 2.51991691,9.9300175 2.3899494,9.80004999 C2.12001687,9.52011997 2.12001687,9.08022994 2.3899494,8.81029743 L6.22898983,4.97125719 L2.4499344,1.19220195 C2.18000187,0.922269433 2.18000187,0.482379405 2.4499344,0.202449388 Z",
  id: "next-icon"
});

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.625rem",
    height: "0.6875rem",
    viewBox: "0 0 8 10",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next.2f6e8aef.svg";
export { ForwardRef as ReactComponent };